export function readableErrorMessage(
  error: unknown,
  fallback = "Er is iets misgegaan.",
): string {
  if (error instanceof Error && error.message.trim()) return error.message;
  if (typeof error === "string" && error.trim()) return error;
  if (!error || typeof error !== "object") return fallback;

  const record = error as Record<string, unknown>;
  for (const key of ["message", "error", "details", "hint"]) {
    const value = record[key];
    if (typeof value === "string" && value.trim()) return value;
    if (value && typeof value === "object") {
      const nested = readableErrorMessage(value, "");
      if (nested) return nested;
    }
  }
  return fallback;
}
